import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import Spacer from '@/components/Spacer';

import useSequence from './use-sequence.hook';
import Label from './Label';
import {
  BaseWrapper,
  Layer,
  Skew,
  BaseElement,
  BaseMargin,
  ChildElement,
  SPRING_CONFIGS,
} from './bits';

function MarginCollapseStyledComponents() {
  const [stepIndex, step, handlers] = useSequence({
    mode: 'interactive',
  });

  const firstSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : -15}%)`,
    config: SPRING_CONFIGS[0],
  });

  const secondSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : 15}%)`,
    config: SPRING_CONFIGS[0],
  });

  return (
    <Wrapper {...handlers}>
      <Layer style={{ zIndex: 1, ...secondSpring }}>
        <Skew>
          <AboveElement>
            <TextWrapper style={{ opacity: stepIndex === 2 ? 1 : 0 }}>
              {`<p />`}
            </TextWrapper>
          </AboveElement>
          <Spacer size={72} />
          <BaseElement>
            <TextWrapper style={{ opacity: stepIndex === 2 ? 1 : 0 }}>
              {`<MainContent />`}
            </TextWrapper>
          </BaseElement>
        </Skew>
      </Layer>

      <Layer
        style={{
          top: 64,
          zIndex: 2,
          ...firstSpring,
        }}
      >
        <Skew>
          <ChildMargin />
          <ChildElement>
            <TextWrapper style={{ opacity: stepIndex === 2 ? 1 : 0 }}>
              {`<Aside />`}
            </TextWrapper>
          </ChildElement>
        </Skew>
        <Label
          orientation="up"
          isVisible={stepIndex === 2}
          style={{
            top: '-20%',
            left: '-25%',
          }}
        >
          margin-top: 72px
        </Label>
      </Layer>
    </Wrapper>
  );
}

const Wrapper = styled(BaseWrapper)`
  height: 350px;
`;

const AboveElement = styled(BaseElement)`
  height: 64px;
`;

const TextWrapper = styled.span`
  transition: opacity 500ms;
  display: inline-block;
  padding: 16px;
`;

const ParentMargin = styled(BaseMargin)`
  height: 72px;
`;
const ChildMargin = styled(BaseMargin)`
  height: 72px;
`;

export default MarginCollapseStyledComponents;
